import { useTheme } from "@mui/material/styles";
import React, { FC, useMemo } from "react";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import { WithChildren } from "utils/types";

const ToastProvider: FC<WithChildren> = ({ children }) => {
  const theme = useTheme();
  const palette = theme.palette as any;

  const toastCssVars = useMemo(() => {
    const success = palette.brandSuccess?.primary ?? "#2CB666";
    const error = palette.brandDanger?.primary ?? "#EC1F3D";
    const warning = palette.brandWarning?.primary ?? "#EACA00";
    const info = palette.brandInfo?.primary ?? "#3280E8";
    const bg = palette.brandBackground?.primary ?? "#FAF9F6";
    const text = palette.brandText?.primary ?? "#111726";
    const fontFamily =
      theme.typography?.fontFamily ??
      '"Maxima Nouva", "Lato", Arial, sans-serif';

    return `
      .Toastify__toast-container {
        --toastify-color-success: ${success};
        --toastify-color-error: ${error};
        --toastify-color-warning: ${warning};
        --toastify-color-info: ${info};
        --toastify-icon-color-success: ${success};
        --toastify-icon-color-error: ${error};
        --toastify-icon-color-warning: ${warning};
        --toastify-icon-color-info: ${info};
        --toastify-color-progress-success: ${success};
        --toastify-color-progress-error: ${error};
        --toastify-color-progress-warning: ${warning};
        --toastify-color-progress-info: ${info};
        --toastify-toast-background: ${bg};
        --toastify-text-color-light: ${text};
        --toastify-font-family: ${fontFamily};
        --toastify-toast-bd-radius: 10px;
        --toastify-toast-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        --toastify-toast-min-height: 56px;
      }
    `;
  }, [theme, palette]);

  return (
    <>
      <style>{toastCssVars}</style>
      {children}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        limit={3}
        theme="light"
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        hideProgressBar={false}
        style={{ fontFamily: theme.typography?.fontFamily }}
      />
    </>
  );
};

export default ToastProvider;
